/**
 * Typography component overrides.
 * Headings use primary text. Body text inherits default colors.
 * NOTE: Do NOT force body1/body2 to text-secondary globally — this breaks
 * contrast in navigation, list items, cards, and other components.
 */

import type { Theme } from '@mui/material/styles';

const typography: Theme['components'] = {
  MuiTypography: {
    styleOverrides: {
      root: {
        variants: [
          { props: { variant: 'h1' }, style: { color: 'var(--mui-palette-text-primary)' } },
          { props: { variant: 'h2' }, style: { color: 'var(--mui-palette-text-primary)' } },
          { props: { variant: 'h3' }, style: { color: 'var(--mui-palette-text-primary)' } },
          { props: { variant: 'h4' }, style: { color: 'var(--mui-palette-text-primary)' } },
          { props: { variant: 'h5' }, style: { color: 'var(--mui-palette-text-primary)' } },
          { props: { variant: 'h6' }, style: { color: 'var(--mui-palette-text-primary)' } },
        ],
      },
    },
  },
};

export default typography;
